import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useProjectsFilter = (config = {}) =>
  useQuery({
    ...config,
    queryKey: ["reports-projects-filter"],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/projects/available-filters?report`,
        signal,
      }),
  });
